import { useState, useEffect } from 'react';

const useScrollPos = ({ debounce = 0, node = window }) => {
	const [pos, setPos] = useState({ x: node.scrollX, y: node.scrollY });

	useEffect(() => {
		let t = 0;
		const onScroll = () => {
			clearTimeout(t);
			t = setTimeout(() => {
				setPos({ x: node.scrollX, y: node.scrollY });
			}, debounce);
		};
		node.addEventListener('scroll', onScroll);

		return () => {
			clearTimeout(t);
			node.removeEventListener('scroll', onScroll);
		};
	}, [debounce, node, setPos]);

	return pos;
};

export default useScrollPos;
